import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Footer } from '../components/Footer';
import { SectionContact } from '../components/SectionContact';
import { SectionFeature } from '../components/SectionFeature';
import { SectionHero } from '../components/SectionHero';
import { SectionWorkflow } from '../components/SectionWorkflow';
export default function HomePage() {
    useEffect(() => {
        const revealItems = document.querySelectorAll('.reveal');
        if ('IntersectionObserver' in window) {
            const revealObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        revealObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.16 });
            revealItems.forEach((item, index) => {
                item.style.transitionDelay = `${Math.min(index * 70, 420)}ms`;
                revealObserver.observe(item);
            });
        }
        else {
            revealItems.forEach((item) => item.classList.add('is-visible'));
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("main", { id: "top", className: "site-main home-view", children: [_jsx(SectionHero, {}), _jsx("div", { id: "docs", className: "nav-anchor", tabIndex: -1, "aria-hidden": "true" }), _jsx(SectionFeature, {}), _jsx(SectionWorkflow, {}), _jsx(SectionContact, {})] }), _jsx(Footer, {})] }));
}
